
const PathList = {
    Login: "/",
    Dashboard:"/dashboard",
    Metrics:"/metrics",
    FunnelAnalytics:"/funnel-analytics",
    UserManagement:"/user",
    UserDetails:"/user/user-profile",
    ContentManagement:"/content-management",
    NotificationManagement:"/notifications",
    ReportManagement:"/report-user",
    ReportUserDetails:"/report-user/report-user-details",
    feedbacks:"/feedbacks",
    HashtagManagement:"/hashtag-management",
    FeedbacksModule:"/feedbacks-module",
    PremiumUsers:"/premium-users",
    Referrals:"/referrals",
    DoggoDig:"/doggo-dig",
    FAQs:"/faqs",
    CommentReasons:"/comment-reasons",
    ReportedComments:"/reported-comments",
    Strike:"/streak-management",
    SpotsModeration:"/spots-moderation",
    SpotTags:"/spot-tags",
    Badges:"/badges",
    Closet:"/closet",
    Events:"/events",
    ReportedWalkIssues:"/reported-walk-issues",
    ReportedWalkIssueDetails:"/reported-walk-issues/details",
}

export default PathList
